(ns practitest.frontend.vsadmin.subs
  (:require
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::view
 (fn [db]
   (get-in db [:options :view])))

(re-frame/reg-sub
 ::x-data
 (fn [db]
   (get-in db [:x-data])))

(re-frame/reg-sub
 ::y-data
 (fn [db]
   (get-in db [:y-data])))

(re-frame/reg-sub
 ::x-trend
 (fn [db]
   (get-in db [:x-trend])))

(re-frame/reg-sub
 ::y-trend
 (fn [db]
   (get-in db [:y-trend])))